export enum DigestType {
  read = "read",
  watch = "watch",
  listen = "listen",
}
